import React, { useMemo, useEffect, useState, useCallback } from 'react'
import styles from './ChatMsgFile.module.css'
import * as fileReq from '../../../../axios/requests/filesReq'
import axios from 'axios';
import FileViewer from 'react-file-viewer';
import noImage from '../../../../assets/no-image.png'
import fileTypeExcel from '../../../../assets/file-types/file-type-excel.png'
import fileTypePdf from '../../../../assets/file-types/file-type-pdf.png'
import fileTypePowerPoint from '../../../../assets/file-types/file-type-powerpoint.png'
import fileTypeTxt from '../../../../assets/file-types/file-type-txt.png'
import fileTypeWord from '../../../../assets/file-types/file-type-word.png'
import fileTypeOther from '../../../../assets/file-types/file-type-other.png'
import { getFileTypeByContentType } from '../../../../util/functions'
import { useTranslation } from "react-i18next";
// import { Button } from 'react-bootstrap';
import FilePreviewModal from '../../../UI/FilePreviewModal/FilePreviewModal'

const ChatMsgFile = ({ fileId, mediaTokenData }) => {
    const [fileType, setFileType] = useState('');
    const [fileBlobUrl, setFileBlobUrl] = useState('');
    const [showFilePreview, setShowFilePreview] = useState(false)

    const [t] = useTranslation('common');

    useEffect(() => {
        const fetchFile = async () => {
            let isFileIsAUrl = false
            try {
                isFileIsAUrl = fileId?.includes("http") || fileId.includes("www.")
                let fileUrl = !isFileIsAUrl ? fileReq.getFileUrl(mediaTokenData?.mediaToken, fileId) : fileId
                const response = await axios.get(fileUrl, { responseType: 'blob' });
                const contentType = response.headers['content-type'];
                setFileType(getFileTypeByContentType(contentType));

                // Convert the blob to a URL
                const blobUrl = URL.createObjectURL(response.data);
                setFileBlobUrl(blobUrl);
            } catch (error) {
                if (isFileIsAUrl) setFileBlobUrl(fileId);
                setFileType('error')
            }
        };
        fetchFile();

        // Cleanup the blob URL when the component unmounts or the file changes
        return () => {
            if (fileBlobUrl) {
                URL.revokeObjectURL(fileBlobUrl);
            }
        };

    }, [fileId])//mediaTokenData

    const onError = useCallback(() => { setFileType('error') }, []);

    const getImageElementBySource = useCallback(
        (src, noBoxShadow) => <img className={`${styles['image-file']} ${noBoxShadow && styles['image-file--noboxshadow']}`} src={src} alt={t('image')} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
        , [])

    const getFilePreviewElement = useCallback((fileType, fileBlobUrl) => (
        <FileViewer
            fileType={fileType}
            filePath={fileBlobUrl}
            onError={onError}
        />
    ), [])

    const onPreviewToggel = useCallback(() => {
        setShowFilePreview(prevState => !prevState)
    }, [])

    let SingleFileContainer;
    let showImage = false
    let isAudio = false
    
    switch (fileType) {
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            SingleFileContainer = getImageElementBySource(fileBlobUrl)
            showImage = true
            break;
        case 'doc':
        case 'docx':
            SingleFileContainer = getImageElementBySource(fileTypeWord, true)
            showImage = true
            break;
        case 'pdf':
            SingleFileContainer = getImageElementBySource(fileTypePdf, true)
            showImage = true
            break;
        case 'mp3':
            isAudio = true
            SingleFileContainer = getFilePreviewElement(fileType, fileBlobUrl)
            break;
        case 'csv':
        case 'xls':
        case 'xlsx':
            SingleFileContainer = getImageElementBySource(fileTypeExcel, true)
            showImage = true
            break;
        case 'pptx':
        case 'ppt':
            SingleFileContainer = getImageElementBySource(fileTypePowerPoint, true)
            showImage = true
            break
        case 'txt':
            SingleFileContainer = getImageElementBySource(fileTypeTxt, true)
            showImage = true
            break
        case 'mp4':
            SingleFileContainer = getFilePreviewElement(fileType, fileBlobUrl)
            break
        case undefined:
        case '':
            getFilePreviewElement(fileType, fileBlobUrl)
            break;
        default:
            showImage = true
            SingleFileContainer = getImageElementBySource(fileTypeOther, true) //getFilePreviewElement(fileType, fileBlobUrl)
    }


    return (
        <>
            <article className={`${styles['file-main']}`}>
                <div className={`msg-image-container ${styles['file-container']} ${showImage && styles['file-container--imagetype']} ${showImage && styles['clickableImg']} ${isAudio && styles['file-container--audiotype']}`} onClick={showImage ? () => window.open(fileBlobUrl, '_blank') : () => { }}>
                    {SingleFileContainer}
                </div>
                {/* <div className={`${styles['file-controller']}`}>
                    <div className={`${styles['file-controller-btns--right']}`}>
                        <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']}`} onClick={onPreviewToggel} title={t('View')}>
                            <i class="fa-regular fa-eye" />
                        </Button>
                        <a target='_blank' href={fileBlobUrl} >
                            <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']}`} title={t('download')} >
                                <i className="fa-regular fa-circle-down" />
                            </Button>
                        </a>
                    </div>
                </div> */}
            </article>
            <FilePreviewModal show={showFilePreview} fileType={fileType} fileUrl={fileBlobUrl} onHide={onPreviewToggel} />
        </>
    )
    // let staticFileUrl = useMemo(()=>{
    //     return fileUrl
    // },[])
}

export default React.memo(ChatMsgFile)